/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { StatusColumn } from "~/components";
import { Column } from "~/types";
import { OSCell } from "~/views/resources/components/OSCell";

type Props = {
  column: Column;
  showValueInOptions?: boolean;
};

export function SidebarItemResourceOsColumn({
  column,
  showValueInOptions,
}: Props) {
  const os = {
    subType: column.data[0],
    type: column.data[1],
  };

  return (
    <When condition={showValueInOptions}>
      <StatusColumn>
        <OSCell os={os} />
      </StatusColumn>
    </When>
  );
}
